// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"b8fe4ab8","279":"e6d15fd8"}[chunkId] + ".chunk.css";
};